// third-party
import { Trans } from 'react-i18next';

// assets
import { IconChecklist } from '@tabler/icons';
import { OverrideIcon } from 'types';

// constant
const icons = {
    IconChecklist
};

// ==============================|| DASHBOARD MENU ITEMS ||============================== //

export interface SystemMenuProps {
    id: string;
    title: React.ReactNode | string;
    type: string;
    children?: {
        id: string;
        title: React.ReactNode | string;
        type: string;
        url: string;
        icon: OverrideIcon;
        breadcrumbs: boolean;
    }[];
}
const item: SystemMenuProps = {
    id: 'tasks',
    title: <Trans i18nKey="Tasks" id="Tasks" />,
    type: 'group',
    children: [
        {
            id: 'task-management',
            title: <Trans i18nKey="Task management" id="Task management" />,
            type: 'item',
            url: '/task-management',
            icon: icons.IconChecklist,
            breadcrumbs: false,
        },
        {
            id: 'task-statistics',
            title: <Trans i18nKey="Task statistics" id="Task statistics" />,
            type: 'item',
            url: '/task-statistics',
            icon: icons.IconChecklist,
            breadcrumbs: false,
        },
    ]
};

export default item;
